import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import Button from 'atoms/button';
import Checkbox from 'atoms/checkbox';
import Icon from 'atoms/icon';
import useWindowDimensions from 'hooks/useWindowDimensions';
import {
  addRecurringPlaceholder,
  editRecurringTime,
  removeRecurringTime,
} from 'store/reducers/recurringAvailability';
import { shortWeekday } from 'util';

import DeleteDayModal from '../../Modals/DeleteDayModal';
import EditHoursModal from '../../Modals/EditHours';
import AvailabilityRange from '../DayAvailability/AvailabilityRange';

export default function AvailabilityDay({
  day,
  checkboxAction,
  dayData,
  openDays,
}) {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const { isOwner } = useSelector((state) => state.user);
  const [isEditHoursOpen, openEditHours] = useState();
  const [isDeleteSlotOpen, openDeleteSlot] = useState();
  const [rangeToRemove, setRangeToRemove] = useState();
  // This is responsible for the animation upon deletion
  const [itemsToAnimate, setItemsToAnimate] = useState([]);
  const isMobile = width < 460;
  const times = dayData?.time;
  const isOpen = openDays.includes(day);
  const hasAvailability = isOpen && dayData;

  const addPlaceholderRange = () => {
    dispatch(addRecurringPlaceholder({ dow: day }));
  };

  const onRemoveRange = ({ uuid, isPlaceholder }) => {
    if (localStorage.getItem('hideAvailabilityRemovalModal')) {
      return fireRemovingAction({ uuid, isPlaceholder });
    }
    setRangeToRemove({ uuid, isPlaceholder });
    openDeleteSlot(true);
  };

  const fireRemovingAction = ({ uuid, isPlaceholder }) => {
    const rangeUuid = uuid || rangeToRemove?.uuid;
    setItemsToAnimate([...itemsToAnimate, uuid]);
    setTimeout(() => {
      dispatch(
        removeRecurringTime({
          uuid: rangeUuid,
          day,
          isPlaceholder: isPlaceholder || rangeToRemove?.isPlaceholder,
        })
      );
      const remainingItems = itemsToAnimate.filter((el) => el !== rangeUuid);
      setItemsToAnimate(remainingItems);
    }, 400);
  };

  return (
    <div
      className={classNames(
        'flex-row justify-between availability-day mb-15 align-start',
        !hasAvailability && 'pt-5 pb-5'
      )}
    >
      <Checkbox
        className={classNames(hasAvailability && 'mb-15')}
        id={day}
        size="extra-small"
        value={!!dayData}
        disable={!isOpen}
        disableInternalCheck
        onClick={({ isChecked }) => checkboxAction(isChecked, day)}
        disabled={!isOpen}
      >
        {shortWeekday(day)}
      </Checkbox>
      {dayData ? (
        <div className="flex-column w-100 mw-300">
          {times.map((range, i) => (
            <div
              key={`${dayData.dow.value}-${range.uuid}`}
              className={classNames(
                'flex-row w-100',
                i < times.length - 1 && 'mb-15',
                itemsToAnimate.includes(range.uuid) &&
                  times.length > 1 &&
                  'deleted-animation deleted-animation-origin-recurring'
              )}
            >
              <AvailabilityRange
                range={range}
                day={day}
                editSlot={editRecurringTime}
              />
              <div className="action-buttons flex-row">
                <Icon
                  name="bin"
                  className="ml-10"
                  onClick={() =>
                    onRemoveRange({
                      uuid: range.uuid,
                      isPlaceholder: range.isPlaceholder,
                    })
                  }
                />
                <div
                  className="flex-row"
                  style={{
                    visibility: i === times.length - 1 ? 'visible' : 'hidden',
                  }}
                >
                  <Icon
                    name="close"
                    className="plus-icon ml-10"
                    style={{
                      fill: '#63637B',
                      width: 14,
                      height: 14,
                    }}
                    onClick={addPlaceholderRange}
                  />
                </div>
              </div>
            </div>
          ))}
          {isMobile && (
            <Button
              size="small"
              text="Add time"
              variant="reverse"
              className="w-fit mt-10"
              onClick={addPlaceholderRange}
            />
          )}
        </div>
      ) : (
        <div className="w-100 mw-300">
          <p className="f13 italic c-secondary-purple">
            {!isOpen ? `${day} is closed.` : 'Unavailable'}
            {!isOpen && isOwner && (
              <button
                className="c-primary-orange edit-hours pointer no-style-btn italic ml-5"
                onClick={() => openEditHours(true)}
              >
                Edit hours
              </button>
            )}
          </p>
        </div>
      )}
      <DeleteDayModal
        isOpen={isDeleteSlotOpen}
        onClose={openDeleteSlot}
        onRemoveRange={fireRemovingAction}
        variant="range"
      />
      <EditHoursModal openModal={openEditHours} isOpen={isEditHoursOpen} />
    </div>
  );
}
